import React from 'react';
import '../less/mobilePay.less';
import advantages_img_1 from '../img/advantages_img_1.png';
import advantages_img_2 from '../img/advantages_img_2.png';
import advantages_img_3 from '../img/advantages_img_3.png';
import advantages_img_4 from '../img/advantages_img_4.png';
import advantages_img_5 from '../img/advantages_img_5.png';
import Advantages from '../../../../../auxiliary-components/shared/AdvantagesBlock';
import hero_img from '../img/hero_img.png';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import advantagesItemsData from '../enums/advantages_items.json';
import serviceUsageItems from '../enums/service_usage_items.json';
import hero_data from '../enums/hero_data.json';
import how_to_block_abank_24_img_01 from '../img/how_to_block_abank_24_img_01.png';
import how_to_block_abank_24_img_02 from '../img/how_to_block_abank_24_img_02.png';
import how_to_block_abank_24_img_03 from '../img/how_to_block_abank_24_img_03.png';
import how_to_block_abank_24_img_04 from '../img/how_to_block_abank_24_img_04.png';
import how_to_block_google_pay_img_01 from '../img/how_to_block_google_pay_img_01.png';
import how_to_block_google_pay_img_02 from '../img/how_to_block_google_pay_img_02.png';
import how_to_block_google_pay_img_03 from '../img/how_to_block_google_pay_img_03.png';
import how_to_block_google_pay_img_04 from '../img/how_to_block_google_pay_img_04.png';
import how_to_block_apple_wallet_img_01 from '../img/how_to_block_apple_wallet_img_01.png';
import how_to_block_apple_wallet_img_02 from '../img/how_to_block_apple_wallet_img_02.png';
import how_to_block_apple_wallet_img_03 from '../img/how_to_block_apple_wallet_img_03.png';
import how_to_block_apple_wallet_img_04 from '../img/how_to_block_apple_wallet_img_04.png';
import how_to_block_apple_watch_img_01 from '../img/how_to_block_apple_watch_img_01.png';
import how_to_block_apple_watch_img_02 from '../img/how_to_block_apple_watch_img_02.png';
import how_to_block_apple_watch_img_03 from '../img/how_to_block_apple_watch_img_03.png';
import how_to_block_apple_watch_img_04 from '../img/how_to_block_apple_watch_img_04.png';
import HowToBlockNew from '../../../../../auxiliary-components/shared/HowToBlockNew';
import howToBlockAbank24ItemsData from '../enums/how_to_block_abank_24_items.json';
import howToBlockGooglePayItemsData from '../enums/how_to_block_google_pay_items.json';
import howToBlockAppleWalletItemsData from '../enums/how_to_block_apple_wallet_items.json';
import howToBlockAppleWatchItemsData from '../enums/how_to_block_apple_watch_items.json';
import Tabs from '../../../../../auxiliary-components/shared/Tabs';

const imagesMap = {
  advantages_img_1,
  advantages_img_2,
  advantages_img_3,
  advantages_img_4,
  advantages_img_5,
  how_to_block_abank_24_img_01,
  how_to_block_abank_24_img_02,
  how_to_block_abank_24_img_03,
  how_to_block_abank_24_img_04,
  how_to_block_google_pay_img_01,
  how_to_block_google_pay_img_02,
  how_to_block_google_pay_img_03,
  how_to_block_google_pay_img_04,
  how_to_block_apple_wallet_img_01,
  how_to_block_apple_wallet_img_02,
  how_to_block_apple_wallet_img_03,
  how_to_block_apple_wallet_img_04,
  how_to_block_apple_watch_img_01,
  how_to_block_apple_watch_img_02,
  how_to_block_apple_watch_img_03,
  how_to_block_apple_watch_img_04
}

const advantagesItems = advantagesItemsData.map(item => ({
  ...item,
  img: imagesMap[item.img]
}));

const howToBlockAbank24Items = howToBlockAbank24ItemsData.map(item => ({
  ...item,
  img: imagesMap[item.img]
}));

const howToBlockGooglePayItems = howToBlockGooglePayItemsData.map(item => ({
  ...item,
  img: imagesMap[item.img]
}));

const howToBlockAppleWalletItems = howToBlockAppleWalletItemsData.map(item => ({
  ...item,
  img: imagesMap[item.img]
}));

const howToBlockAppleWatchItems = howToBlockAppleWatchItemsData.map(item => ({
  ...item,
  img: imagesMap[item.img]
}));

const tabs = [
  {tab: 'abank24', title: 'MOBILE_PAY_NEW_TABS_INFO_TITLE_01'},
  {tab: 'google-pay', title: 'MOBILE_PAY_NEW_TABS_INFO_TITLE_02'},
  {tab: 'apple-wallet', title: 'MOBILE_PAY_NEW_TABS_INFO_TITLE_03'},
  {tab: 'apple-watch', title: 'MOBILE_PAY_NEW_TABS_INFO_TITLE_04'}
];

export default function template() {

  return (
    <div className="mobile-pay-new">
      <Hero
        data={hero_data}
        img={hero_img}
      />
      <div className="content">
        <Advantages
          items={advantagesItems}
          title={'MOBILE_PAY_NEW_ADVANTAGES_TITLE'}
          subtitle={'MOBILE_PAY_NEW_ADVANTAGES_SUBTITLE'}
          subtitleTag={'div'}
        />
        <div className="service-usage">
          <div className="container">
            <h2 className="service-usage__title">{this.l10n('MOBILE_PAY_NEW_SERVICE_USAGE_TITLE')}</h2>
            <div className="service-usage__body">
              {serviceUsageItems.map((item, index) => (
                <div key={index} className="service-usage__item item-service-usage">
                  <div className="item-service-usage__title">{this.l10n(item.title)}</div>
                  <div className="item-service-usage__text">{this.l10n(item.text)}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab} title={'MOBILE_PAY_NEW_TABS_INFO_TITLE'} subtitle={'MOBILE_PAY_NEW_TABS_INFO_SUBTITLE'}>
          <HowToBlockNew
            items={howToBlockAbank24Items}
          />
          <HowToBlockNew
            items={howToBlockGooglePayItems}
          />
          <HowToBlockNew
            items={howToBlockAppleWalletItems}
          />
          <HowToBlockNew
            items={howToBlockAppleWatchItems}
          />
        </Tabs>
      </div>
    </div>
  )
}
